import DeleteIcon from '@assets/icons/delete.svg';
import React from 'react';
import { APP_MODAL_ROUTES } from '@/navigators/routes';
import { AppModalStackParams } from '@/navigators/types';
import { createStyles } from '@/contexts/theme-context';
import { formatCurrency } from '@/utils/money';
import { ModalContainer } from '@/components/modal-container';
import { PartialPaymentScreenComponent } from '@/components/payments/partial-payment-screen-component';
import { StackScreenProps } from '@react-navigation/stack';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useNavigation } from '@react-navigation/native';
import { View } from 'react-native';

type Props = StackScreenProps<
  AppModalStackParams,
  APP_MODAL_ROUTES.PartialPayment
>;

export const PartialPaymentScreen: React.FC<Props> = ({ route }) => {
  const {
    currencyCode,
    initialAmountInMicros,
    invoiceNumber,
    invoiceTotalInMicros,
    onClear,
    onSave,
  } = route.params;
  const { goBack } = useNavigation();
  const [styles] = useStyles();

  return (
    <ModalContainer
      navigationHeaderProps={{
        BackButtonIcon: DeleteIcon,
        centerTitle: true,
        onBackPress: goBack,
        showBackButton: true,
        title: (
          <View style={styles.headerTitle}>
            <Typography variant="label-lg">{invoiceNumber}</Typography>
            <Typography textAlign="center" variant="paragraph-md">
              {formatCurrency(invoiceTotalInMicros, currencyCode)}
            </Typography>
          </View>
        ),
      }}
    >
      <PartialPaymentScreenComponent
        currencyCode={currencyCode}
        initialAmountInMicros={initialAmountInMicros}
        invoiceTotalInMicros={invoiceTotalInMicros}
        onClear={
          onClear
            ? () => {
                onClear();
                goBack();
              }
            : undefined
        }
        onSave={(amount) => {
          goBack();
          onSave(amount);
        }}
      />
    </ModalContainer>
  );
};

const useStyles = createStyles((theme) => ({
  headerTitle: {
    alignItems: 'center',
    paddingTop: theme.sk.spacing.spaceSmall,
  },
}));
